const generateCouponToast = (state = null, action) => {
    if (action.type === "SET_EDIT_COUPON_TOAST") {
        return action.payload;
    } else {
        return state;
    }
};

export default generateCouponToast;
